module.exports = __webpack_public_path__ + "img/dark-gradient.8885ae50.png";